export const commonPlaceholders = {
	specify: 'Specify',
	more: 'Tell us more',
	optionalSpecify: 'Specify. If none, leave blank',
	tagBox: 'Type to see options, type a comma to add a new item',
};
